import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { formatPhoneNumber } from "../utils/formatnumber";

const SuccessModal = ({ open, setOpen , setCallData, call_data, decodeToken}) => {
  const [twilio, setTwilio] = useState(JSON.parse(localStorage.getItem("organization"))?.twilio_integration)
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Call Initiated</div>


        <div className="lg:text-[14px] text-[13px] text-center">
        Your call was initiated successfully. You should receive a call from <span className='font-semibold'>
         
         {formatPhoneNumber(call_data.fromNumber)}</span> shortly and will then be connected to the receipient.
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'rgba(232,231,249,1)',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    setOpen(false);
                    setCallData((prev) => ({
                      ...prev,
                      recipient: "",
                      callMethod: "forwarding_device",
                    }));
                   // window.location.reload()
                }}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default SuccessModal;
